module.exports = __webpack_public_path__ + "img/symbol_10_x10.76e2508c.png";